<template>
    <Modal :show="show" @close="close()">
      Username:
      <input class="form-control" placeholder="email" v-on:keyup.enter="login" v-model="username"/>
    </Modal>
</template>

<script>
  import Modal from '@/components/models/Modal'

  export default {
    name: 'WidgetAdmin',
    props: ['show'],
    extends: Modal,
    components: {
      Modal
    },
    data () {
      return {
        username: ''
      }
    },
    methods: {
      login: function () {
        console.log('impersonating')
        this.$store.dispatch('getToken', this.username)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/WidgetAdmin.vue